import './AlertBar.scss';
import { ReactElement } from 'react';
import { Alert, AlertType } from '../models/Alert';
import { CountdownAlert } from './alerts/countdown/CountdownAlert';
import { TextAlert } from './alerts/text/TextAlert';

interface IProps {
  alerts: Alert[];
  onAlertOutdated: (alert: Alert) => void;
}

export const AlertBar = ({ alerts, onAlertOutdated }: IProps): ReactElement => {
  const renderRestartCountdownAlert = (alert: Alert): ReactElement => (
    <CountdownAlert
      key={alert.id}
      alert={alert}
      onAlertOutdated={onAlertOutdated}
    />
  );
  const renderTextAlert = (alert: Alert): ReactElement => (
    <TextAlert
      key={alert.id}
      alert={alert}
      onAlertOutdated={onAlertOutdated}
    />
  );

  const renderAlert = (alert: Alert): ReactElement => {
    switch (alert.type) {
      case AlertType.RESTART_COUNTDOWN:
        return renderRestartCountdownAlert(alert);
      case AlertType.TEXT:
        return renderTextAlert(alert);
      default:
        return <></>;
    }
  };

  return <div className='alerts-bar'>{alerts.map((a) => renderAlert(a))}</div>;
};
